import { render, staticRenderFns } from "./FeatureJoins.vue?vue&type=template&id=ded6cd86&"
import script from "./FeatureJoins.vue?vue&type=script&lang=js&"
export * from "./FeatureJoins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports